import { useState } from "react";
import { RARITIES, VISIBILITIES } from "@/lib/mtg";
import { PLAYS_AS, RIGHTS_TEXT, VISUAL_FRAMES } from "@/lib/planar";

function ApplyControl({ label, children, onApply, testid }) {
  return (
    <div className="flex min-w-[180px] flex-1 flex-col">
      <span className="field-label">{label}</span>
      <div className="flex gap-2">
        {children}
        <button type="button" className="btn-outline px-3 py-2 text-xs" onClick={onApply} data-testid={`${testid}-apply`}>Apply</button>
      </div>
    </div>
  );
}

export function BulkToolbar({ sets, backs, applyAll, rights, setRights }) {
  const [setCode, setSetCode] = useState("");
  const [vis, setVis] = useState("public");
  const [rarity, setRarity] = useState("common");
  const [back, setBack] = useState("");
  const [playsAs, setPlaysAs] = useState("plane");
  const [frame, setFrame] = useState("custom");
  return (
    <div className="panel mb-6 flex flex-wrap gap-4 p-4" data-testid="bulk-toolbar">
      <ApplyControl label="Set code → all" onApply={() => applyAll({ set_code: setCode.toUpperCase() })} testid="bulk-apply-set">
        <input className="field uppercase" list="bulk-my-sets" placeholder="e.g. EMB" maxLength={8} value={setCode}
          onChange={(e) => setSetCode(e.target.value)} data-testid="bulk-apply-set-input" />
        <datalist id="bulk-my-sets">{sets.map((s) => <option key={s.set_id} value={s.code}>{s.name}</option>)}</datalist>
      </ApplyControl>
      <ApplyControl label="Visibility → all" onApply={() => applyAll({ visibility: vis })} testid="bulk-apply-visibility">
        <select className="field capitalize" value={vis} onChange={(e) => setVis(e.target.value)} data-testid="bulk-apply-visibility-select">
          {VISIBILITIES.map((v) => <option key={v} value={v}>{v}</option>)}
        </select>
      </ApplyControl>
      <ApplyControl label="Rarity → all" onApply={() => applyAll({ rarity })} testid="bulk-apply-rarity">
        <select className="field capitalize" value={rarity} onChange={(e) => setRarity(e.target.value)} data-testid="bulk-apply-rarity-select">
          {RARITIES.map((v) => <option key={v} value={v}>{v}</option>)}
        </select>
      </ApplyControl>
      <ApplyControl label="Card back → all" onApply={() => applyAll({ card_back_id: back })} testid="bulk-apply-back">
        <select className="field" value={back} onChange={(e) => setBack(e.target.value)} data-testid="bulk-apply-back-select">
          <option value="">Default back</option>
          {backs.map((b) => <option key={b.card_back_id} value={b.card_back_id}>{b.name}</option>)}
        </select>
      </ApplyControl>
      <ApplyControl label="Plays as → all" onApply={() => applyAll({ plays_as: playsAs })} testid="bulk-apply-plays-as">
        <select className="field" value={playsAs} onChange={(e) => setPlaysAs(e.target.value)} data-testid="bulk-apply-plays-as-select">
          {PLAYS_AS.map((p) => <option key={p.value} value={p.value}>{p.label}</option>)}
        </select>
      </ApplyControl>
      <ApplyControl label="Visual frame → all" onApply={() => applyAll({ frame })} testid="bulk-apply-frame">
        <select className="field" value={frame} onChange={(e) => setFrame(e.target.value)} data-testid="bulk-apply-frame-select">
          {VISUAL_FRAMES.map((f) => <option key={f.value} value={f.value}>{f.label}</option>)}
        </select>
      </ApplyControl>
      <label className="flex w-full cursor-pointer items-start gap-2 rounded-lg border border-[#2A3447] p-3 text-xs text-slate-300" data-testid="bulk-rights-label">
        <input type="checkbox" className="mt-0.5 h-4 w-4 accent-amber-500" checked={rights} onChange={(e) => setRights(e.target.checked)} data-testid="bulk-rights-checkbox" />
        <span>Externally designed Plane and Phenomenon rows: {RIGHTS_TEXT} Their images are kept exactly as uploaded.</span>
      </label>
      <p className="w-full text-xs text-slate-500">New set codes are created automatically under your account when you publish.</p>
    </div>
  );
}
